import { getErrorMessage, getErrorType, ErrorType } from './error-utils';

// Map error types to toast titles
const ERROR_TITLES: Record<ErrorType, string> = {
  [ErrorType.AUTHENTICATION]: 'Authentication Error',
  [ErrorType.AUTHORIZATION]: 'Permission Denied',
  [ErrorType.NETWORK]: 'Network Error',
  [ErrorType.VALIDATION]: 'Validation Error',
  [ErrorType.NOT_FOUND]: 'Not Found',
  [ErrorType.SERVER]: 'Server Error',
  [ErrorType.UNKNOWN]: 'Error',
};

// Get user-friendly error title and message
export function getErrorToastContent(error: unknown): { title: string; message: string } {
  const errorType = getErrorType(error);
  const message = getErrorMessage(error);

  return {
    title: ERROR_TITLES[errorType],
    message,
  };
}
